import { useLocation } from "react-router";
import { Navigate, Outlet } from "react-router-dom";


const useAuth = () => {
  if (localStorage.getItem('loggedInUserName')) {
    return true
  } else {

    return false;
  }


};


const ProtectedRoutes = () => {
  const isAuth = useAuth();
  const location = useLocation();
  return isAuth ? <Outlet /> : <Navigate to="/login" replace state={{ from: location }} />;
};

export default ProtectedRoutes;